import i18n from "src/i18n/config";
import { z } from "zod";

const usernameMaxLength = 250;
const passwordMinLength = 8;
const passwordMaxLength = 250;

// Printable ASCII without spaces — credentials are passed in a URL.
const credentialsCharsetRegex = /^[!-~]+$/;

/**
 * The charset check comes first on purpose. `useValidationSchema` keeps the last error per field,
 * so this order shows the length hint for a short value and the charset hint only for bad characters.
 */
export const setBwcCredentialsValidationSchema = z
    .object({
        bwcAccount: z
            .string(i18n.t("common:validation.fieldRequired"))
            .regex(credentialsCharsetRegex, i18n.t("sidepanels:devicePanel.bwcTab.credentials.validation.usernameCharset"))
            .min(1, i18n.t("common:validation.fieldRequired"))
            .max(usernameMaxLength, i18n.t("sidepanels:devicePanel.bwcTab.credentials.validation.usernameMax")),
        bwcSecret: z
            .string(i18n.t("common:validation.fieldRequired"))
            .regex(credentialsCharsetRegex, i18n.t("sidepanels:devicePanel.bwcTab.credentials.validation.passwordCharset"))
            .min(passwordMinLength, i18n.t("common:validation.custom.passwordMin"))
            .max(passwordMaxLength, i18n.t("sidepanels:devicePanel.bwcTab.credentials.validation.passwordMax")),
        bwcSecretRepeat: z.string(i18n.t("common:validation.fieldRequired")).min(1, i18n.t("common:validation.fieldRequired")),
    })
    .refine((values) => values.bwcSecret === values.bwcSecretRepeat, {
        message: i18n.t("common:validation.passwordMatch"),
        path: ["bwcSecretRepeat"],
    });
